import request from '@/libs/request'
import { toast } from '../libs/utils'

// 查询树形模板结构
export async function getDoctorTempList () {
  let data = await request.post('/doctor/doctorReportTemplate/queryDoctorReportTemplateList', {}, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询树形模板结构异常！' })
  }
}
// 查询医生一级分类模板
export async function getDoctorFirstTempList (params) {
  let data = await request.post('/doctor/doctorReportTemplate/queryFirstDoctorReportCategory', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询一级分类模板异常！' })
  }
}
// 查询医生二级分类模板
export async function getDoctorSecondTempList (params) {
  let data = await request.post('/doctor/doctorReportTemplate/querySecondDoctorReportCategory', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询二级分类模板异常！' })
  }
}
// 查询医生诊断模板
export async function getDoctorThreeTempList (params) {
  let data = await request.post('/doctor/doctorReportTemplate/queryDoctorReportTemplateListByCategoryId', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询二级分类模板异常！' })
  }
}
// 新增报告模板分类
export async function addTempCategory (params) {
  let data = await request.post('/doctor/doctorReportTemplate/addDoctorReportTemplateCategory', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '新增报告模板分类异常' })
  }
}
// 编辑报告模板分类
export async function editTempCategory (params) {
  let data = await request.post('/doctor/doctorReportTemplate/updateCategoryNameById', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '编辑报告模板分类异常' })
  }
}
// 删除报告模板分类
export async function removeTempCategory (params) {
  let data = await request.post('/doctor/doctorReportTemplate/deleteCategoryById', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '删除报告模板分类异常' })
  }
}
// 新增医生报告模板
export async function addDoctorTemp (params) {
  let data = await request.post('/doctor/doctorReportTemplate/addDoctorReportTemplate', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '新增医生报告模板异常' })
  }
}
// 编辑医生报告模板
export async function editDoctorTemp (params) {
  let data = await request.postJson('/doctor/doctorReportTemplate/updateById', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '编辑医生报告模板异常' })
  }
}
// 查询医生报告模板
export async function getDoctorTempInfo (params) {
  let data = await request.post('/doctor/doctorReportTemplate/queryDoctorReportTemplateById', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询医生报告模板异常' })
  }
}
// 领取编辑报告
export async function reeceiveReport (params) {
  let data = await request.post('/order/orderCheckReport/taskClaim', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '领取编辑报告异常' })
    return false
  }
}
//属于同一个检查单的所有待编辑的报告
export async function getMyWritingTask (params) {
  let data = await request.post('/order/orderCheckReport/getMyWritingTask', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取待编辑的报告列表异常' })
  }
}
// 获取报告修改历史
export async function getReportEditHistory (params) {
  let data = await request.post('/order/orderCheckReport/getReportHistory', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result || []
  } else {
    toast({ msg: data.message || '获取报告修改历史异常' })
  }
}
// 获取历史检查
export async function getReportHistory (params) {
  let data = await request.post('/order/orderCheckReport/getCheckHistory', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取历史检查异常' })
  }
}
// 查询报告
export async function getReportPatientInfo (params) {
  let data = await request.post('/order/orderCheckReport/getPatientInfo', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取报告患者信息异常' })
  }
}
// 保存接口
export async function saveReportContent (params) {
  let data = await request.post('/order/orderCheckReport/saveReport', params)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '保存报告异常' })
  }
}
// 提交审核
export async function commitReportReview (params) {
  let data = await request.post('/order/orderCheckReport/commitReportReview', params)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '提交审核异常' })
    return false
  }
}
// 获取上传报告列表
export async function getUploadList (params) {
  let data = await request.post('/order/orderCheckReport/getById', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取上传报告列表异常' })
  }
}
// 上传报告
export async function uploadReport (params) {
  let data = await request.postFile('/order/orderCheckReport/uploadReportFile', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '上传报告异常' })
    return false
  }
}
// 分片上传文件
export async function uploadSliceReport (params) {
  let data = await request.postFile('/order/orderCheckReport/uploadReportFileSlice', params)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    return false
  }
}
// 删除上传的报告
export async function removeUpLoadReport (params) {
  let data = await request.post('/order/orderCheckReport/deleteReportFile', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '删除上传报告异常' })
    return false
  }
}
// 放弃当前编写报告
export async function giveUpWriting (params) {
  let data = await request.post('/order/orderCheckReport/giveUpWriting', params)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '放弃当前编写报告异常' })
  }
}
// 放弃全部编写报告
export async function giveUpAllWriting (params) {
  let data = await request.post('/order/orderCheckReport/giveUpAllWriting', params)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '放弃全部编写报告异常' })
  }
}
// 查看审核不通过原因
export async function viewAuditNotPassWhy (params) {
  let data = await request.post('/order/orderCheckReport/denyCommentList', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查看审核不通过原因异常' })
  }
}
// 报告召回
export async function recall (params) {
  let data = await request.postFile('/order/orderCheckReport/recall', params)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '召回报告异常' })
    return false
  }
}
// 查询病种标签
export async function getDiseaseTags (params) {
  let data = await request.post('/bdc/commonDiseaseIcd10/queryEffectiveDiseaseIcd', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询病种标签异常' })
  }
}
// 查询病种标签
export async function getDieaseByVal (params) {
  let data = await request.post('/bdc/commonDiseaseIcd10/queryByValue', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询病种标签异常' })
  }
}
// 根据检查ID查询报告信息
export async function geReportInfoByCheck (params) {
  let data = await request.post('/order/orderCheckReport/query', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询报告信息异常' })
  }
}
// 后处理下载影像
export async function downloadImage (params) {
  let data = await request.post('/order/orderCheckImageInfo/getImgZipUrl', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '下载影像异常' })
  }
}
// 编辑疾病历史
export async function editMedicalHistory (params) {
  let data = await request.post('/order/orderCheckOrderInfo/editMedicalHistory', params)
  if (data && data.code && data && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '编辑疾病历史异常' })
  }
}
// 后处理报告重新运算
export async function operation (params) {
  let data = await request.post('/order/orderCheckReport/startGewuPostprocess', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '重新运算异常' })
    return false
  }
}
// 改变报告打印状态
export async function changePrinter (params) {
  let data = await request.post('/order/orderCheckReport/updateReportDownloadFinishStatus', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '改变报告打印状态异常' })
  }
}
// 下载报告
export async function getPrintReport (params) {
  let data = await request.post('/order/orderCheckReport/getDownloadReportDetail', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取打印报告异常' })
  }
}
// 查询上一次工作人的数据
export async function historySetWorker (params) {
  let data = await request.post('/order/orderPersonnel/queryPersonnelLastTime', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取历史工作人异常' })
  }
}
// 删除报告模板
export async function deleteTemplate (params) {
  let data = await request.post('/doctor/doctorReportTemplate/deleteDoctorReportById', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '删除模板异常' })
  }
}

// 上传AI报告文件
export async function upLoadAiReportFile (params) {
  let data = await request.postFile('/order/orderCheckReport/uploadFile', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '上传报告文件异常' })
    return false
  }
}

export async function checkReportFile(params) {
  let url = '/order/orderCheckReport/checkReportFile'
  if (params.reportId) url = url + '?reportId=' + params.reportId
  if (params.reportType) url = url + '&reportType=' + params.reportType
  delete params.reportId
  delete params.reportType
  let data = await request.postJson(url, params.fileParam, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '保存报告数据异常' })
    return false
  }
}